import { coreApi } from '$api'
import { GetOrdersResponse } from '$models'
import { singletonQueryClient } from '$utils'
import { Dayjs } from 'dayjs'

/**
 * Get Orders information for the report period, grouped by report interval.
 * @param start (optional) Start of report
 * @param end (optional) End of report
 * @param interval (optional) Interval to divide report
 * @return Promise<GetOrdersResponse[]>
 */
export const getPosOrders = async (
  start: Dayjs | undefined,
  end: Dayjs | undefined,
  interval: string | undefined
): Promise<GetOrdersResponse[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: ['pos-orders', start, end, interval],
    queryFn: async () => {
      return await coreApi.posOrders(start, end, interval)
    },
  })
}
